var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBzColdness(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.53 45.17l6.84 4-2 3.49-6.84-4L53.4 56l-3.95.48-1.22-10.32L40 41.38v9.67l8.23 6.2-2.38 3.2L40 56v8h-4v-8l-5.84 4.41-2.38-3.2L36 51.05v-9.67l-8.23 4.78-1.22 10.27L22.6 56l.87-7.3-6.84 4-2-3.49 6.84-4-6.71-2.89 1.56-3.68 9.45 4.07L34 37.89l-8.23-4.78-9.45 4.07-1.56-3.68 6.71-2.89-6.84-4 2-3.49 6.84 4-.87-7.3 3.95-.48 1.22 10.27L36 34.4v-9.45l-8.23-6.2 2.38-3.2L36 20v-8h4v8l5.84-4.41 2.38 3.2L40 24.95v9.45l8.23-4.78 1.22-10.27 3.95.48-.87 7.3 6.84-4 2 3.49-6.84 4 6.71 2.89-1.56 3.68-9.45-4.07L42 37.89l8.23 4.78 9.45-4.07 1.56 3.68-6.71 2.89z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/BZ_Coldness.74d1e356.svg";
export { SvgBzColdness as ReactComponent };